import { Undo } from "@pebblepad/ckeditor";
import { IToolbarItem } from "./interfaces/IToolbarItem";

export const redo: IToolbarItem = {
    name: "redo",
    pluginConfig: null,
    plugins: [Undo]
};
